var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMetronome = function SvgMetronome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.351 16.364q0-.152-.069-.287l-3.085-6.042 1.593-2.217a2.338 2.338 0 0 0 2.566-3.703l.61-.887a.631.631 0 0 0-1.039-.716l-.61.885a2.338 2.338 0 0 0-2.563 3.699L15.55 8.77l-2.888-5.655c-.715-1.4-2.717-1.4-3.432 0L2.612 16.077a.6.6 0 0 0-.069.287v2.052a2.36 2.36 0 0 0 2.359 2.358h12.09a2.36 2.36 0 0 0 2.36-2.358zm-4.63-6.441L11.54 3.689a.664.664 0 0 0-1.184 0L4.261 15.625h6.362zm-2.543 5.702h5.456l-2.266-4.437zm5.91 1.263H3.807v1.527c0 .606.49 1.097 1.096 1.097h12.09c.606 0 1.096-.491 1.096-1.096zm.47-10.204a1.075 1.075 0 1 1 0-2.15 1.075 1.075 0 0 1 0 2.15",
    clipRule: "evenodd"
  })));
};
export default SvgMetronome;